<template>
  <div>
    <!--    <div class="title-bar">付款</div>-->
    <base-title-bar-scroll-page ref="container" :showTitleBar="false" :back="true" back-text="主页" title="培训费支付"
                                @onBackClick="onBackClick">
      <!-- 顶部品牌图片 -->
      <img src="https://cdn.keihong.tech/img/20250608221055941.png" alt="品牌头图" style="width: 100%; height: auto; display: block; margin-bottom: 12px;" />
      <div v-if="type === '3'" class="custom-card" style="padding: 16px;">
        <!-- 大标题 -->
        <div class="big-title">老年人能力评估师（三级高级）</div>
        <!-- 联系人卡片 -->
        <div class="contact-card">
          <div class="contact-detail">
            <div class="contact-name">联系人：周老师 惠州市康复医学会培训部主任</div>
            <div class="contact-phone">咨询电话：13059568829 <span class="contact-action" @click="callPhone">点击拨打</span></div>
          </div>
        </div>
        <div class="custom-divider"></div>
        <div class="form-title">请填写以下信息：</div>
        <van-form @submit="submitPayment">
          <van-field
            v-model="patientName"
            label="姓名:"
            placeholder="点击输入"
            required
            class="custom-field"
          />
          <van-field
            v-model="patientMobile"
            label="电话:"
            placeholder="点击输入"
            required
            type="tel"
            class="custom-field"
          />
          <van-field
            v-model="remarks"
            label="现从事职业:"
            placeholder="点击输入"
            required
            class="custom-field"
          />
          <div class="fee-row">
            <div class="fee-label">费用：</div>
            <div class="fee-amount">￥2680.00</div>
          </div>
          <van-button class="custom-btn" type="primary" native-type="submit">立即报名</van-button>
        </van-form>
      </div>
      <div v-else style="margin: 16px;height: 90%;background-color: white;border-radius: 16px;padding-top: 16px">
        <div id="payTitle"
             style="display: flex;background-color: white;border-radius: 16px;padding: 8px;align-items: center;">
          <img alt="Logo" class="logo" src="https://cdn.keihong.tech/img/202312211710121.png">
          <div class="institution-name">
            惠州市康复医学会-康复理疗师资格认证考试报名-{{ type === '1' ? '初级' : '高级' }}
          </div>
        </div>
        <div class="divider"></div> <!-- Divider line -->
        <div class="inputBoxWrapper">
          <van-field
            v-model="fee"
            class="inputBox"
            label="付款金额"
            type="number"
          >
            <template #button>
              <span>元</span>
            </template>
          </van-field>
        </div>
        <div class="input-wrapper">
          <van-field
            v-model="patientName"
            label="姓名"
            placeholder="请输入姓名"
            type="text"
          />
          <van-field
            v-model="patientMobile"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
          />
        </div>
        <div class="textarea-wrapper">
          <van-field
            v-model="remarks"
            placeholder="请输入现从事职业"
            rows="5"
            style=" border: 1px solid #ccc;border-radius: 8px;"
            type="textarea"
          />
        </div>
        <div class="button-wrapper">
          <van-button style="width: 100%;" type="primary" @click="submitPayment">立即支付</van-button>
        </div>
        <div class="footer">技术支持：动优远程康复服务云平台</div>
      </div>
    </base-title-bar-scroll-page>
    <van-popup v-model="showPopup" :close-on-click-overlay="false" class="popup-wrapper" position="bottom">
      <div style="padding: 16px;text-align: center">
        <img alt="Success Logo" class="success-logo" src="https://cdn.keihong.tech/img/202312211813200.png">
        <div class="success-message">支付凭证，请截图保存</div>
        <div style=" text-align: center;font-size: 14px;margin: 20px 0;">订单编号：{{ outTradeNo }}</div>
        <div style=" text-align: center;font-size: 14px;margin: 20px 0;">
          支付内容： {{ this.type === '1' ? '康复理疗师资格认证考试报名-初级' : this.type === '2' ? '康复理疗师资格认证考试报名-高级' : '老年人能力评估师(三级/高级)报名' }}-{{
            this.patientName
          }}+{{ this.patientMobile }}
        </div>
        <van-button style="width: 100%;" type="primary" @click="refreshPage">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>

import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Dialog, Notify } from 'vant'
import WxPayDao from '@/h5/doucan/network/WxPayDao'
import wx from 'weixin-jsapi'
import axios from 'axios'

export default {
  name: 'QuickPayPageHuizhoupeixun01',
  components: { BaseTitleBarScrollPage },
  data () {
    return {
      type: '',
      fee: '',
      showPopup: false,
      hospital: '',
      amount: '',
      remarks: '',
      patientName: '',
      patientMobile: '',
      testMobile: ['18008000808', '13610164743', '18520535303', '18501011010'],
      openId: '',
      payStatus: false,
      appsecret: '',
      appid: '',
      code: '',
      openid: '',
      paySignInfo: null,
      outTradeNo: '', // 动优支付系统里面的订单号 ordernum
      remark: ''
    }
  },
  mounted () {
    this.$refs.container.stopLoading()
    this.hospital = this.$route.query.hospital
    this.type = this.$route.query.type
    console.log('type: ' + this.type)
    if (this.type === 1) {

    } else if (this.type === 2) {

    }

    // 判断是否是微信浏览器
    const isWeChatBrowser = () => {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('micromessenger')
    }

    if (isWeChatBrowser()) {
      // console.log("This is a WeChat browser");
      this.initWx()
    } else {
      // console.log("This is not a WeChat browser");
    }

    // const ua = window.navigator.userAgent.toLowerCase()
    // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //   // alert('是微信浏览器')
    //   // 初始化微信-获取openid
    //   this.initWx()
    // }
  },
  methods: {
    onBackClick () {
      // 重定向到某个url
      this.hospital = '中国民间中医医药研究开发协会中蒙民族医药研究发展分会'
      if (this.hospital) {
        window.location.href = 'https://doucan.jianerkanggz.cn/#/home/square?hospital=' + this.hospital
      } else {
        window.location.href = 'https://doucan.jianerkanggz.cn/#/home/square'
      }
    },
    refreshPage () {
      this.showPopup = false
      // location.reload()
      // window.location.href = 'https://doucan.jianerkanggz.cn/#/home/square?hospital=' + this.hospital
      // this.onBackClick()
    },
    submitPayment () {
      if (this.type === '3') {
        // type=3时，必填校验
        if (!this.patientName || !this.patientMobile || !this.remarks) {
          Notify({
            type: 'danger',
            message: '请填写姓名、电话和现从事职业'
          })
          return
        }
        // 固定费用2680
        this.fee = 2680
      } else {
        if (!this.patientName || !this.patientMobile) {
          Notify({
            type: 'danger',
            message: '请填写姓名和手机号'
          })
          return
        }
      }
      this.pay()
    },
    async initWx () {
      await this.getAppid()
      const openid = this.$store.state.user.openId
      if (openid) {
        this.openid = openid
      } else {
        await this.getMpOpenID()
      }
    },
    async pay () {
      let fee = 0
      if (this.type === '3') {
        if (this.testMobile.includes(this.patientMobile)) {
          fee = 0.01
        } else {
          fee = 2680
        }
      } else if (this.testMobile.includes(this.patientMobile)) {
        fee = 0.01
      } else {
        fee = this.totalPrice
      }
      const fromActivity = this.type === '3' ? '老年人能力评估师(三级/高级)报名' : '扫码支付-惠州市康复医学会-康复理疗师资格认证考试报名'
      const goods = this.type === '1' ? '康复理疗师资格认证考试报名（初级）' : this.type === '2' ? '康复理疗师资格认证考试报名（高级）' : '老年人能力评估师(三级/高级)'
      const profile = {
        serveType: 0,
        mobile: this.patientMobile,
        patientName: this.patientName,
        patientMobile: this.patientMobile,
        orderType: '',
        fee: fee,
        fromActivity: fromActivity,
        goods: goods,
        openId: this.openid,
        remark: this.remarks // 现从事职业
      }
      console.log('提交订单', profile)
      const data = await WxPayDao.createOrder(profile)
      console.log('支付qrcode', data)
      if (data.code === 1) {
        this.paySignInfo = data.data
        this.outTradeNo = data.data.outTradeNo
        // 调起微信支付
        wx.config({
          // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false
          debug: false,
          // 必填，公众号的唯一标识
          appId: this.paySignInfo.sign.appId,
          // 必填，生成签名的时间戳
          timestamp: this.paySignInfo.sign.timeStamp,
          // 必填，生成签名的随机串
          nonceStr: this.paySignInfo.sign.nonceStr,
          // 必填，签名
          signature: this.paySignInfo.sign.paySign,
          // 必填，需要使用的JS接口列表
          jsApiList: ['chooseWXPay']
        })
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['chooseWXPay'],
            success: function (res) {
              console.log('seccess')
              console.log('hskdjskjk', res)
            },
            fail: function (res) {
              console.log('fail')
              console.log(res)
            }
          })
          const _that = this
          wx.chooseWXPay({
            // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            timestamp: this.paySignInfo.sign.timeStamp,
            // 支付签名随机串，不长于 32 位
            nonceStr: this.paySignInfo.sign.nonceStr,
            // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            package: this.paySignInfo.sign.packageValue,
            // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            signType: this.paySignInfo.sign.signType,
            // 支付签名
            paySign: this.paySignInfo.sign.paySign,
            // 支付成功后的回调函数
            success: function (res) {
              if (res.errMsg === 'chooseWXPay:ok') {
                console.log('支付成功', res)
                _that.payStatus = true
                Dialog.alert({
                  message: '支付成功'
                }).then(() => {
                  // on close
                  // todo 跳转到支付成功页面，显示支付凭证和提示
                  // _that.$router.push(
                  //   '/salepage/20230001/result?outTradeNo=' + _that.outTradeNo
                  // )
                  _that.showPopup = true
                })
              } else {
                Dialog({ message: JSON.stringify(res) })
                _that.payStatus = false
              }
            },
            fail: function (res) {
              Dialog({ message: '支付失败:' + JSON.stringify(res) })
              _that.payStatus = false
            }
          })
        })
        wx.error((err) => {
          alert(err)
        })
      } else {
        console.log('支付失败', data)
      }
    },
    async getOpenId (code) {
      // this.info = '正在获取getOpenId'
      const url = '/quick/pay/openid?code=' + code

      axios
        .get(url)
        .then((res) => {
          // this.info = JSON.stringify(res)
          this.openid = res.data.data.openid
          console.log('openid = ', res.data.data.openid)
          if (!this.openid) {
            this.getCodeApi()
            return
          }
          this.$store.commit('user/setOpenId', this.openid)
          // const profile = this.$store.state.apply20230001.profile
          // profile.openId = this.openid
          // this.$store.commit('apply20230001/update', profile)
        })
        .catch((err) => {
          console.log('err', err)
          this.getCodeApi()
        })
    },
    getCodeApi () {
      const appid = 'wxcb56667c309e369b'
      const urlNow = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base' // snsapi_userinfo 非静默授权用户有感知 snsapi_base 静默授权用户无感知
      // const scope = 'snsapi_userinfo' // snsapi_userinfo 非静默授权用户有感知 snsapi_base 静默授权用户无感知
      const url =
        'https://open.weixin.qq.com' +
        '/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urlNow +
        '&response_type=code&scope=' +
        scope +
        '#wechat_redirect'
      window.location.href = url
    },
    getUrlKey (name) {
      // 获取url 参数
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [undefined, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    async getAppid () {
      const url = '/quick/pay/appid'
      const res = await axios.get(url)
      console.log('appid', res)
      this.appid = res.data.data.codeName
      this.appsecret = res.data.data.codeValue
    },
    async getMpOpenID () {
      const code = this.getUrlKey('code')
      if (code) {
        this.code = code
        await this.getOpenId(code)
      } else {
        this.getCodeApi()
      }
    },
    callPhone () {
      // 拨打电话
      window.location.href = 'tel:13059568829'
    },
    openMap () {
      window.open('https://uri.amap.com/marker?position=114.42072,23.08663&name=惠州市河南岸裕隆布综合市场二楼211室', '_blank')
    }
  },
  watch: {
    // 根据type调整fee的值，当this.tpye发生变化，若为1，则fee为100，为2，则fee为200，为3，则fee为300
    type: function (newVal, oldVal) {
      console.log('newVal', newVal)
      if (newVal === '1') {
        this.fee = 1980
      } else if (newVal === '2') {
        this.fee = 5980
      }
    }

  },
  computed: {
    totalPrice () {
      return this.fee
    }

  }
}
</script>
<style scoped>

.logo {
  float: left;
  width: 60px;
  height: 60px;
}

.institution-name {
  float: right;
  width: 100%;
  font-size: 14px;
  margin-left: 16px;
}

.divider {
  height: 1px;
  background-color: #ccc;
  margin: 16px;
}

.inputBoxWrapper {
  margin: 16px;
}

.inputBox {
  border: 1px solid #ccc;
  border-radius: 16px;
}

.textarea-wrapper {
  margin: 16px;
}

.textarea-wrapper .van-field__control {
}

.button-wrapper {
  margin: 16px;

}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  color: #7e7e7e;
}

.input-wrapper {
  margin: 16px;
}

.popup-wrapper {
  height: 50vh;
}

.success-logo {
  width: 70px;
  height: 70px;
  margin: 0 auto;
}

.success-message {
  text-align: center;
  font-size: 20px;
  margin: 20px 0;
}

.custom-card {
  margin: 16px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 18px 0 rgba(0,0,0,0.06);
  padding: 20px 18px 24px 18px;
}
.contact-info {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
}
.contact-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 12px;
  border: 1.5px solid #e6e6e6;
}
.contact-detail {
  flex: 1;
}
.contact-name {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 2px;
}
.contact-phone, .contact-address {
  font-size: 13px;
  color: #888;
  margin-bottom: 2px;
}
.contact-action {
  color: #1aad19;
  margin-left: 8px;
  cursor: pointer;
  font-weight: 500;
}
.custom-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 12px 0 18px 0;
}
.form-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 12px;
}
.custom-field {
  border-radius: 12px;
  border: 1px solid #e6e6e6;
  margin-bottom: 12px;
  background: #fafbfc;
  --van-field-label-color: #333;
  --van-field-label-font-weight: 600;
}
.fee-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.fee-label {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}
.fee-amount {
  color: #ff4d00;
  font-size: 22px;
  font-weight: bold;
  margin-left: 8px;
}
.custom-btn {
  width: 100%;
  background: linear-gradient(90deg, #1aad19 0%, #23c23c 100%);
  color: #fff;
  border-radius: 24px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 8px;
  box-shadow: 0 2px 8px 0 rgba(26,173,25,0.08);
  border: none;
}
.big-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 18px;
  color: #222;
  letter-spacing: 1px;
}
.contact-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.06);
  padding: 16px 14px 12px 14px;
  margin-bottom: 18px;
  border: 1px solid #f2f2f2;
}

</style>
